import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DeliveryIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M21.5,14H22v-.72a1.07,1.07,0,0,0-.14-.52L19.29,8.46A1,1,0,0,0,18.43,8H15.5a.5.5,0,0,0-.5.5V16H14V5.47a.5.5,0,0,0-.5-.5H2.5a.5.5,0,0,0-.5.5v10a.5.5,0,0,0,.5.5H3v.5a.5.5,0,0,0,.5.5h.55a2.53,2.53,0,0,1,.45-1,2.5,2.5,0,0,1,4,0A2.53,2.53,0,0,1,9,17h7.1a2.53,2.53,0,0,1,.45-1,2.5,2.5,0,0,1,4,0A2.53,2.53,0,0,1,21,17h.55a.5.5,0,0,0,.5-.5V15h-.5a.5.5,0,0,1,0-1ZM17,12.37V10h1.56l.24.4,1.2,2Z"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "6.5",
    cy: "17.47",
    r: "1.5"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "18.5",
    cy: "17.47",
    r: "1.5"
  })]
}), 'DeliveryIcon');